export default function filterNoNullable<T>(
  array: T[],
): (T extends null | undefined | false | 0 ? never : T)[] {
  return array.filter(Boolean) as ReturnType<typeof filterNoNullable<T>>
}
